/* The Bird Porch — oznacava stavku menija za stranicu na kojoj je kupac.
   Horizon tema ne postavlja aria-current, pa kupac ne vidi gde se nalazi.
   Resava i pristupacnost (citaci ekrana) i vizuelnu oznaku.

   Dve zamke koje su vec zagrizle:
   1. Tema renderuje I mobilnu fioku I desktop meni. Oznacavamo SVE linkove
      koji vode na isti put, ne samo prvi pogodak — inace se oznaci samo
      fioka, koja se na desktopu ne vidi.
   2. overflow-list komponenta prepravlja stavke posle ucitavanja, pa jedno
      postavljanje na DOMContentLoaded nestane. Otud MutationObserver. */
(function () {
  'use strict';

  var SELECTOR = '.menu-list__link[href], .menu-drawer__menu-item[href]';
  var scheduled = false;

  function normalise(value) {
    if (!value) return '';
    try {
      var path = new URL(value, window.location.origin).pathname;
      return path.length > 1 ? path.replace(/\/+$/, '') : path;
    } catch (e) {
      return '';
    }
  }

  function mark() {
    scheduled = false;

    var here = normalise(window.location.pathname);
    if (!here || here === '/') return;

    var links = document.querySelectorAll(SELECTOR);
    if (!links.length) return;

    /* najduzi poklopljeni put pobedjuje: /collections/apparel nadjaca /collections */
    var bestPath = '';

    for (var i = 0; i < links.length; i++) {
      var target = normalise(links[i].getAttribute('href'));
      if (!target || target === '/') continue;

      if ((target === here || here.indexOf(target + '/') === 0) && target.length > bestPath.length) {
        bestPath = target;
      }
    }

    /* Menjamo samo ono sto stvarno treba da se promeni — bez ove provere
       svaki upis bi ponovo okinuo observer i vrteo se u krug. */
    for (var j = 0; j < links.length; j++) {
      var link = links[j];
      var isCurrent = bestPath !== '' && normalise(link.getAttribute('href')) === bestPath;
      var hasCurrent = link.getAttribute('aria-current') === 'page';

      if (isCurrent && !hasCurrent) {
        link.setAttribute('aria-current', 'page');
      } else if (!isCurrent && hasCurrent) {
        link.removeAttribute('aria-current');
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(mark);
  }

  function start() {
    mark();

    var header = document.querySelector('#header-group') || document.body;
    if (!header || typeof MutationObserver !== 'function') return;

    new MutationObserver(schedule).observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
